export default function Button(props: propsButton ) {
    return(
        <button type={props.type} className="btn btn-primary btn_contact_form col-12 mt-3" onClick={props.onClick} disabled={props.disabled}>
            {props.children}
        </button>
    )
}
 interface propsButton{
    children: React.ReactNode,
    onClick?():void,
    type: "button" | "submit",
    disabled:boolean
 }

 Button.defaultProps = {
     type: "button",
     disabled: true
 }